import React, { FunctionComponent } from 'react';

const PersonInviteIcon: FunctionComponent<React.PropsWithChildren<{ className?: string }>> = ({
  className
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99935 8.00008C11.4727 8.00008 12.666 6.80675 12.666 5.33341C12.666 3.86008 11.4727 2.66675 9.99935 2.66675C8.52602 2.66675 7.33268 3.86008 7.33268 5.33341C7.33268 6.80675 8.52602 8.00008 9.99935 8.00008ZM9.99935 4.00008C10.7327 4.00008 11.3327 4.60008 11.3327 5.33341C11.3327 6.06675 10.7327 6.66675 9.99935 6.66675C9.26602 6.66675 8.66602 6.06675 8.66602 5.33341C8.66602 4.60008 9.26602 4.00008 9.99935 4.00008ZM4.66602 12.0001C4.66602 10.2267 8.21935 9.33341 9.99935 9.33341C11.7793 9.33341 15.3327 10.2267 15.3327 12.0001V13.3334H4.66602V12.0001ZM5.99935 12.0001C6.14602 11.5201 8.20602 10.6667 9.99935 10.6667C11.7993 10.6667 13.866 11.5267 13.9993 12.0001H5.99935ZM3.99935 8.00008V10.0001H2.66602V8.00008H0.666016V6.66675H2.66602V4.66675H3.99935V6.66675H5.99935V8.00008H3.99935Z"
      fill="currentColor"
    />
  </svg>
);

export default PersonInviteIcon;
